import PlaceIcon from '@mui/icons-material/PlaceOutlined';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import useResponsive from '@/hooks/useResponsive';

import Map from '../dependencies/map';
import NoShipmentsYet from '../NoShipmentsYet/NoShipmentsYet';
import useFrequentlyStates from './useFrequentlyStates';

const FrequentlyStates = () => {
  const hook = useFrequentlyStates();
  const isDesktop = useResponsive('up', 'xl');
  return (
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2, height: '100%' }}>
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1.5rem' }}>
        Estados a los que más envías
      </Typography>

      {!hook.data.data || hook.data.data?.length === 0 ? (
        <NoShipmentsYet />
      ) : (
        <Box
          display="flex"
          flexDirection={{ xxs: 'column', xl: 'row' }}
          sx={{ overflowY: 'auto', overflowX: 'hidden' }}
        >
          <Box sx={{ width: { xxs: '100%', xl: '50%' } }}>
            {hook.data.data?.map((state, index) => (
              <StateCard
                key={state.state}
                state={state.state}
                count={state.count}
                position={index + 1}
                percentage={hook.calculatePercentage(state.count)}
              />
            ))}
          </Box>
          <svg
            role="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 793 498"
            style={{
              width: isDesktop ? '50%' : '100%',
              height: '100%',
            }}
          >
            {Map.locations.map((estado) => {
              return (
                <path
                  key={estado.id}
                  d={estado.path}
                  aria-label={estado.name}
                  id={estado.objKey ? estado.objKey : estado.name}
                  style={{
                    fill: hook.getColor(estado),
                    stroke: '#fff',
                  }}
                ></path>
              );
            })}
          </svg>
        </Box>
      )}
    </Card>
  );
};

export default FrequentlyStates;

interface StateCardProps {
  state: string;
  count: number;
  position: number;
  percentage: string;
}

const StateCard = ({ state, count, position, percentage }: StateCardProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      mb="1rem"
      sx={{
        width: '100%',
        minWidth: '100%',
        border: '1px solid #e1e1e1',
        padding: '0.5rem',
        borderRadius: '1rem',
      }}
    >
      <PlaceIcon fontSize="small" />
      <Box display="flex" flexDirection="column" ml="1rem">
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {state} {position}°
        </Typography>
        <Typography
          variant="body2"
          sx={{ span: { fontWeight: (theme) => theme.typography.caption } }}
        >
          {percentage}% <span>({count})</span>
        </Typography>
      </Box>
    </Box>
  );
};
